import { FC } from "react";
import { FileItemProps } from "@/components/file-item/types";
import styles from "./styles.scss";
import clsx from "clsx";
import { getFileIcon } from "@/utils";

export const FileItem: FC<FileItemProps> = ({
  fileName,
  extension,
  className,
  fileItemNameClassName,
  disabled,
}) => {
  return (
    <div className={clsx(styles.fileItemWrapper, className)}>
      <div className={styles.fileItemIcon}> {getFileIcon(extension)}</div>
      <span
        className={clsx(
          styles.fileItemName,
          disabled && styles.fileItemNameDisabled,
          fileItemNameClassName,
        )}
      >
        {fileName}
      </span>
    </div>
  );
};
